import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { Button } from 'components/Button/Button'
import { addToast } from 'components/Toast/Toast'
import { useModalContext } from 'context/modalContext'
import { deleteFansGroup } from 'services/endpoints/fanGroup'
import './_delete-fans-group-modal.scss'

interface DeleteFansGroupModalProps {
    activeGroup: { id: string; name: string }
    closeDrawer?: () => void
    customCloseFn?: () => void
    dontClearModal?: boolean
}

export const DeleteFansGroupModal = ({
    activeGroup,
    closeDrawer,
    dontClearModal
}: DeleteFansGroupModalProps) => {
    const modalData = useModalContext()
    const queryClient = useQueryClient()
    const { t } = useTranslation()

    const deleteGroup = useMutation(
        async () => await deleteFansGroup(activeGroup.id),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('fans-groups')
                addToast('sucess', t('successfullyDeleted'))
                if (!dontClearModal) {
                    modalData.clearModal()
                }
                if (closeDrawer) {
                    closeDrawer()
                }
            },
            onError: () => {
                addToast('error', t('error:anErrorOccuredPleaseTryAgain'))
                if (!dontClearModal) {
                    modalData.clearModal()
                }
                if (closeDrawer) {
                    closeDrawer()
                }
            }
        }
    )

    return (
        <div className='delete-fans-group-modal-container'>
            <p className='delete-fans-group-modal-text'>
                {t('areYouSureYouWantToDelete')}{' '}
                <span className='delete-fans-group-name'>
                    {activeGroup.name}{' '}
                </span>
                ?
            </p>
            <div className='delete-fans-group-modal-button-container'>
                <Button
                    text={t('back')}
                    color='black'
                    clickFn={() => {
                        modalData.clearModal()
                    }}
                    height='3'
                    width='13'
                    font='mont-14-normal'
                />
                <Button
                    text={t('delete')}
                    color='blue'
                    customClass={`delete-fans-group-modal-button ${
                        deleteGroup.isLoading
                            ? 'delete-fans-group-modal-button-loading'
                            : ''
                    }`}
                    clickFn={() => {
                        deleteGroup.mutate()
                    }}
                    height='3'
                    width='13'
                    font='mont-14-normal'
                />
            </div>
        </div>
    )
}
